import './Header.css';
import logo from '../../assets/Optimiz Color.png';

const Header = () => {
  return (
    <header className="main-header">
      <div className="container header-container">
        <div className="logo">
          <a href="/"><img src={logo} alt="Logo" className="logo-img" /></a>
        </div>
        <nav className="main-nav">
          <a href='/'>Home</a>
          <a href="/contact-us">Contact</a>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
        </nav>
        <div className="header-buttons">
  <a href="/contact-us" className="btn btn-primary">Get Started</a>
</div>

      </div>
    </header>
  );
};

export default Header;
